<div class="tooltip-content">
    <app-tooltip-text></app-tooltip-text>
</div>
